import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class CourseService {
  constructor(protected http: HttpClient, private apiService: ApiService) {}

  get path(): string {
    return this.apiService.getApiUrl() + 'course';
  }

  getCampaigns(): Observable<any> {
    return this.http.get(`${this.path}/campaigns`);
  }
}
